import React, { FC } from 'react';
import styled from 'styled-components';
import { Tooltip } from 'src/presentation/components/agent_desktop_components';

import TrashIcon from '@ad-scripts/presentation/components/common/icons/trash';

type DeleteButtonProps = {
  className?: string;
  disabled?: boolean;
  icon?: any;
  id: number | string;
  onClick: Function;
  message?: any;
};

const DeleteButton: FC<DeleteButtonProps> = ({
  id,
  disabled,
  className,
  onClick,
  icon: IconComponent = TrashIcon,
  message,
}) => {
  return (
    <Tooltip message={message || 'Delete'} style={{ left: '5px' }} margin={13}>
      <StyledDeleteButton className={className} disabled={disabled} data-aid={`deleteButton-${id}`} onClick={onClick}>
        <IconComponent />
      </StyledDeleteButton>
    </Tooltip>
  );
};

export const StyledDeleteButton = styled.button`
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  visibility: hidden;
  & svg {
    height: 16px;
  }
`;

export default DeleteButton;
